import { DataCollectionBatchGraphActionTypes } from '../constants/ApiConstants';


const initialState = {
  loading: false,
  DCPatientSkillAcqGraphData: null,
  DCPatientBehaviourGraphData: null,
  AnnotationLabel: [],
  BaselineLabel: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case DataCollectionBatchGraphActionTypes.get_masterData.REQUEST:
      return {
        ...state,
        loading: true,
        masterData: null,
      };
    case DataCollectionBatchGraphActionTypes.get_masterData.SUCCESS:
      return {
        ...state,
        loading: false,
        masterData: payload,
      };
    case DataCollectionBatchGraphActionTypes.get_DC_PatientSkillAcqBATCHGraphAPI.REQUEST:
      return {
        ...state,
        loading: true,
        DCPatientSkillAcqGraphData: null,
      };
    case DataCollectionBatchGraphActionTypes.get_DC_PatientSkillAcqBATCHGraphAPI.SUCCESS:
      return {
        ...state,
        loading: false,
        DCPatientSkillAcqGraphData: payload,
      };
    case DataCollectionBatchGraphActionTypes.get_DC_PatientBehaviourBATCHGraphAPI.REQUEST:
      return {
        ...state,
        loading: true,
        DCPatientBehaviourGraphData: null,
      };
    case DataCollectionBatchGraphActionTypes.get_DC_PatientBehaviourBATCHGraphAPI.SUCCESS:
      return {
        ...state,
        loading: false,
        DCPatientBehaviourGraphData: payload,
      };
      case DataCollectionBatchGraphActionTypes.get_TargetAndProgramDatas.REQUEST:
      return {
        ...state,
        loading: true,
        targetsAndProgramsData: null,
      };
    case DataCollectionBatchGraphActionTypes.get_TargetAndProgramDatas.SUCCESS:
      return {
        ...state,
        loading: false,
        targetsAndProgramsData: payload,
      };
    case DataCollectionBatchGraphActionTypes.get_BehaviorsReductionsData.REQUEST:
      return {
        ...state,
        loading: true,
        behaviorsReductionsData: null,
      };
    case DataCollectionBatchGraphActionTypes.get_BehaviorsReductionsData.SUCCESS:
      return {
        ...state,
        loading: false,
        behaviorsReductionsData: payload,
      };
    case DataCollectionBatchGraphActionTypes.set_GraphAnnotationAndBaselineBlank.SUCCESS:
        return {
          ...state,
          loading: false,
          AnnotationLabel: [],
          BaselineLabel: [],
        };
    case DataCollectionBatchGraphActionTypes.set_GraphAnnotationValue.REQUEST:
          return {
            ...state,
            loading: false,
            AnnotationLabel: [],
          };
    case DataCollectionBatchGraphActionTypes.set_GraphAnnotationValue.SUCCESS:
        return {
          ...state,
          loading: false,
          AnnotationLabel: payload,
        };
    case DataCollectionBatchGraphActionTypes.set_GraphBaselineValue.REQUEST:
        return {
          ...state,
          loading: false,
          BaselineLabel: [],
        };
    case DataCollectionBatchGraphActionTypes.set_GraphBaselineValue.SUCCESS:        
        return {
          ...state,
          loading: false,
          BaselineLabel: payload,
        };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollectionBatchGraph/reducers/index.js